import React from 'react';
import Button, { ButtonProps } from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

export default function ButtonWithLoading({
  loading,
  children,
  startIcon,
  disabled,
  ...rest
}: ButtonProps & { loading: boolean }) {
  return (
    <Button
      startIcon={loading ? <CircularProgress color="inherit" size={20} /> : startIcon}
      disabled={loading || disabled}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      {children}
    </Button>
  );
}
